import React, { useEffect, useState, useCallback } from "react";
import { Skeleton, ErrorState } from "../ui/LoadingStates";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const STAT_CONFIG = [
  { key: "present_days", label: "Present",    color: "#00ff90" },
  { key: "absent_days",  label: "Absent",     color: "#f87171" },
  { key: "wfh_days",     label: "WFH",        color: "#60a5fa" },
  { key: "late_flags",   label: "Late Flags", color: "#fbbf24" },
  { key: "total_days",   label: "Total Days", color: "rgba(255,255,255,0.4)" },
];

export default function AttendanceStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    setLoading(true); setError(null);

    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split("T")[0];
    const end   = today.toISOString().split("T")[0];

    fetch(`${API_BASE}/api/attendance/stats?start=${start}&end=${end}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => { if (!res.ok) throw new Error(`HTTP ${res.status}`); return res.json(); })
      .then(data => setStats(data))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {STAT_CONFIG.map(s => (
          <div key={s.key} className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] p-4 text-center"
               style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
            <Skeleton width={40} height={22} />
            <Skeleton width="60%" height={9} />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return <ErrorState message="Couldn't load attendance stats" detail={error} onRetry={load} />;
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {STAT_CONFIG.map(({ key, label, color }) => (
        <div key={key}
          className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-4 text-center">
          <p className="text-2xl font-bold" style={{ color }}>
            {stats?.[key] ?? 0}
          </p>
          <p className="text-xs text-white/40 mt-1 uppercase tracking-wider">{label}</p>
        </div>
      ))}
    </div>
  );
}